import { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { MoreVertical, Edit, Trash2 } from "lucide-react";

const CardActionMenu = ({
  data,
  handleEditClick,
  handleDelete,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown isOpen={open} toggle={() => setOpen(!open)}>
      <DropdownToggle
        tag="div"
        style={{
          cursor: "pointer",
          width: 34,
          height: 34,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#DC2626",
        }}
      >
        <MoreVertical size={18} color="#000" />
      </DropdownToggle>

      <DropdownMenu end>

        <DropdownItem onClick={() => handleEditClick(data)}>
          <Edit size={16} className="mr-2"  color="#D97706" />
          Edit
        </DropdownItem>

        <DropdownItem
          onClick={() => handleDelete(data)}
          className="text-danger"
        >
          <Trash2 size={16} className="mr-2" color="#DC2626" />
          Delete
        </DropdownItem>

      </DropdownMenu>
    </Dropdown>
  );
};

export default CardActionMenu;